import React, { useContext } from "react";
import { MOBILE_TOOLS } from "../../../../constants/Constants";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import Tool from "../Tools/ToolComponents/Tool";
import { is } from "date-fns/locale";
import MPRToolbar from "../Tools/ToolComponents/MPRToolbar";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import { isMobile } from "react-device-detect";
import themeContext from "../../../../context/theme/ThemeContext";
import { useTranslation } from "react-i18next";
import { logAmplitudeEventWithUsernameAndRole } from "../../../../helpers/Amplitude";
import userContext from "../../../../context/users/UserContext";
import { toolStyle } from "../../styles/styles";
import Overlay from "../../../../components/SVGComponents/Tools/Overlay";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import KeyImages from "../Tools/ToolComponents/KeyImage/KeyImages";

const toolBarFlex = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const MobileToolbar = () => {
  const { username } = useContext(userContext);
  const { theme } = useContext(themeContext);
  const { sharedViewer } = useContext(studyviewerContext);
  const { activeModality } = useContext(ThumbnailContext);
  const { isMPRActive, showOverlay, setShowOverlay, viewportLoadingComplete } =
    useContext(ViewportContext);
  const { showKeyImagesAndTextAnnotation } = useContext(studyReportContext);
  const { t } = useTranslation();

  return (
    <>
      <div
        className={`cursor-pointer ${!viewportLoadingComplete && 'disable-toolbar'}`}
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <div
          onClick={() => {
            setShowOverlay(!showOverlay);
            logAmplitudeEventWithUsernameAndRole(
              "EVENT_BASIC_OVERLAY_TOOL_USED",
              {},
              username
            );
          }}
          style={{ ...toolStyle }}
        >
          <>
            <div
              style={{
                height: "65%",
                width: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Overlay
                color={
                  showOverlay
                    ? theme.palette.activeTool
                    : theme.palette.inactiveTool
                }
              />
            </div>
            <span
              style={{
                fontSize: "9px",
                lineHeight: "100%",
                fontWeight: "400",
                //color: "#FFFFFF",
                //color: "var(--navbar-header-popup-color-txt)",
                color: "var(--mobile-color-txt)",
              }}
            >
              {t("viewer.overlay.overlay")}
            </span>
          </>
        </div>
        {isMPRActive ? (
          <MPRToolbar />
        ) : (
          <>
            {MOBILE_TOOLS.map((tool, index) => {
              if (!tool.NotFor.includes(activeModality)) {
                return (
                  <div key={index} style={{ ...toolBarFlex, height: "100%" }}>
                    <Tool tool={tool} />
                  </div>
                );
              }
            })}
          </>
        )}

        {showKeyImagesAndTextAnnotation && (
          <div
            className="cursor-pointer"
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <KeyImages/>
          </div>
        )}
      </div>
    </>
  );
};

export default MobileToolbar;
